import View from "./tenant-view"
import Form from "./tenant-form"
import Members from "./membership/membership-list"

const Tenant = { View, Form, Members }

export default Tenant
